import { defineComponent as _defineComponent } from 'vue'
import { OrganizationUser } from '@/modules/Organizations/types'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSettingsUserChip',
  props: {
    user: null
  },
  setup(__props: any) {


const { getAvatar } = useImage()

return { __sfc: true,getAvatar }
}

})